import { Stack, Typography } from '@mui/material'
import { OutOfOfficeIndicator } from '@omnea-app/fe-users-and-groups/OutOfOfficeIndicator'
import { CSS_CLASSES } from './constants'

interface UserInfoProps {
  name: string
  isOutOfOffice?: boolean
  email?: string
}

export const UserInfo = ({ name, isOutOfOffice, email }: UserInfoProps) => {
  return (
    <Stack gap={1} className={`${CSS_CLASSES.USER_INFO}`}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="Body14pxMedium" color="neutralDark.500">
          {name}
        </Typography>
        {isOutOfOffice && <OutOfOfficeIndicator />}
      </Stack>
      <Typography variant="Body12pxRegular" color="neutralLight.900">
        {email}
      </Typography>
    </Stack>
  )
}
